module.exports = __webpack_public_path__ + "static/media/Dine-in-1-bg.bbbc371f.png";